import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { checkIcon, pencilIcon, xIcon } from '@progress/kendo-svg-icons';
import { FormFieldWrapper, FormFieldWrapperProps } from '@cs-cms/ui';

interface RtEditableFieldWrapperProps extends FormFieldWrapperProps {
  canEditReadOnlyField: boolean;
  isInEditMode: boolean;
  onStartEdit?: () => void;
  onSaveEdit?: () => void;
  onCancelEdit?: () => void;
}

export const RtEditableFieldWrapper: React.FC<RtEditableFieldWrapperProps> = props => {
  const {
    onChange,
    onFocus,
    onBlur,
    name,
    value,
    validationMessage,
    touched,
    modified,
    visited,
    id,
    valid,
    disabled,
    hint,
    label,
    wrapperStyle,
    optional,
    children,
    tooltipMessage,
    isLoading,
    onRefresh,
    canEditReadOnlyField,
    isInEditMode,
    onStartEdit,
    onSaveEdit,
    onCancelEdit,
    showRefreshButton,
    leadingActionButtons
  } = props;

  const shouldShowEditActions = canEditReadOnlyField && isInEditMode;

  const actionButtons = shouldShowEditActions ? (
    <>
      {leadingActionButtons}
      <Button
        type="button"
        svgIcon={checkIcon}
        size="small"
        fillMode="flat"
        onClick={onSaveEdit}
        title="Save"
        aria-label="Save"
        className="cpsFieldActionButtonCompact"
      />
      <Button
        type="button"
        svgIcon={xIcon}
        size="small"
        fillMode="flat"
        onClick={onCancelEdit}
        title="Cancel"
        aria-label="Cancel"
        className="cpsFieldActionButtonCompact"
      />
    </>
  ) : (
    <>
      {leadingActionButtons}
      {canEditReadOnlyField && (
        <Button
          type="button"
          svgIcon={pencilIcon}
          size="small"
          fillMode="flat"
          onClick={onStartEdit}
          title="Edit"
          aria-label="Edit"
          className="cpsFieldActionButtonCompact"
        />
      )}
    </>
  );

  return (
    <FormFieldWrapper
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      name={name}
      value={value}
      validationMessage={validationMessage}
      touched={touched}
      modified={modified}
      visited={visited}
      id={id}
      valid={valid}
      disabled={disabled}
      hint={hint}
      label={label}
      wrapperStyle={wrapperStyle}
      optional={optional}
      tooltipMessage={tooltipMessage}
      isLoading={isLoading}
      onRefresh={onRefresh}
      showRefreshButton={shouldShowEditActions ? false : showRefreshButton}
      leadingActionButtons={actionButtons}
    >
      {children}
    </FormFieldWrapper>
  );
};
